<template lang="pug">
  div
    a.btn.btn-primary.btn-outline.btn-sm(v-if="type === 'shipping'" v-b-modal="'create-shipping-modal'") {{ trans('labels.frontend.account.profile.add-shipping-address') }}
    a.btn.btn-primary.btn-outline.btn-sm(v-if="type === 'billing'" v-b-modal="'create-billing-modal'") {{ trans('labels.frontend.account.profile.add-billing-address') }}
    shipping-address-modal(v-if="type === 'shipping'" @created="onCreated" name="create-shipping-modal")
    billing-address-modal(v-if="type === 'billing'" @created="onCreated" name="create-billing-modal")
</template>

<script>
import ShippingAddressModal from '../modals/ShippingAddressModal.vue';
import BillingAddressModal from '../modals/BillingAddressModal.vue';

export default {
  components: {
    BillingAddressModal,
    ShippingAddressModal,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  methods: {
    onCreated(address) {
      this.$emit('created', address);
    },
  },
};
</script>
